import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";

const API_BASE = process.env.REACT_APP_API_BASE_URL || "https://doctorisin-genesis-1-0.onrender.com";
const raw = axios.create({ baseURL: API_BASE });

export default function DoctorAutoLogin() {
  const nav = useNavigate();
  const [msg, setMsg] = useState<string>("");

  async function run() {
    setMsg("Logging in…");

    // hardcoded test creds
    const email = "drtest@example.com";
    const pin = "983921";

    try {
      // 1) get token
      const res = await raw.post("/auth/login_doctor_pin", { email, pin });
      const token = (res.data?.access_token || res.data?.token || "").toString().trim();
      const doctorId = res.data?.doctor_id ?? res.data?.doctor?.id ?? undefined;

      if (!token) {
        setMsg("No token returned from server.");
        return;
      }

      // 2) store ONLY doctor keys + role (prevents cross-role collisions)
      localStorage.setItem("role", "doctor");
      localStorage.setItem("doctor_access_token", token);
      localStorage.setItem("doctor_token", token);
      localStorage.setItem("access_token", token);
      localStorage.setItem("token", token);
      if (doctorId != null) localStorage.setItem("doctor_id", String(doctorId));

      // 3) verify with explicit Authorization header (no interceptors)
      await raw.get("/doctor/me", {
        headers: { Authorization: `Bearer ${token}` },
      });

      setMsg("Verified. Redirecting…");
      nav("/doctor-portal", { replace: true });
    } catch (e: any) {
      const status = e?.response?.status;
      const detail = e?.response?.data?.detail ?? e?.response?.data;
      console.error("AutoLogin failed:", e);
      setMsg(`FAILED: HTTP ${status ?? "??"} :: ${typeof detail === "string" ? detail : JSON.stringify(detail)}`);
    }
  }

  return (
    <div style={{ minHeight: "100vh", display: "grid", placeItems: "center" }}>
      <div style={{ width: 520, padding: 18, borderRadius: 12, background: "white" }}>
        <h2>DEV: Doctor Auto Login (DrTest)</h2>
        <p>This bypasses DoctorLogin.tsx completely.</p>
        <button onClick={run} style={{ padding: "10px 14px" }}>
          Auto Login drtest@example.com
        </button>
        <div style={{ marginTop: 12, fontFamily: "monospace", whiteSpace: "pre-wrap" }}>{msg}</div>
        <div style={{ marginTop: 12 }}>
          <Link to="/login">Back</Link>
        </div>
      </div>
    </div>
  );
}
